(() => {
  const cfg = window.cartRewards || {};
  if (!cfg.giftVariantId) return;

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  const nativeFetch = window.fetch.bind(window);
  const isGift = item => item.variant_id === cfg.giftVariantId;

  let busy = false;
  let queued = false;
  let timer;

  const getCart = () => nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
  const post = (url, body) =>
    nativeFetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });

  // Prüft den Warenkorb und fügt das Geschenk hinzu bzw. entfernt es. Gibt true zurück, wenn etwas geändert wurde.
  async function syncGift() {
    if (busy) { queued = true; return false; }
    busy = true;
    let changed = false;

    try {
      const cart = await getCart();
      const giftLines = cart.items.filter(isGift);
      const giftQty = giftLines.reduce((s, i) => s + i.quantity, 0);
      // Warenwert nach Rabatten, ohne das Geschenk
      const subtotal = cart.total_price - giftLines.reduce((s, i) => s + i.final_line_price, 0);
      // Schwelle 0 = Land ohne Geschenk (z. B. Schweiz)
      const qualifies = cfg.giftThreshold > 0 && subtotal >= cfg.giftThreshold;

      if (qualifies && giftQty === 0) {
        await post('cart/add.js', { items: [{ id: cfg.giftVariantId, quantity: 1, properties: { _gift: 'true' } }] });
        changed = true;
      } else if (!qualifies && giftQty > 0) {
        const updates = {};
        giftLines.forEach(line => { updates[line.key] = 0; });
        await post('cart/update.js', { updates });
        changed = true;
      } else if (qualifies && giftQty > 1) {
        const updates = {};
        giftLines.forEach((line, i) => { updates[line.key] = i === 0 ? 1 : 0; });
        await post('cart/update.js', { updates });
        changed = true;
      }
    } catch (e) {
      console.warn('[cart-gift]', e);
    } finally {
      busy = false;
    }

    if (queued) {
      queued = false;
      return (await syncGift()) || changed;
    }
    return changed;
  }

  // Drawer, Zähler und Warenkorbseite nach einer Änderung aktualisieren
  async function refreshUI() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    if (document.querySelector('.shopify-section--main-cart')) {
      location.reload();
      return;
    }

    const drawer = document.querySelector('cart-drawer');
    const section = drawer && drawer.closest('.shopify-section');
    if (section) {
      try {
        const sectionId = section.id.replace('shopify-section-', '');
        const html = await nativeFetch(`${root}?section_id=${sectionId}`).then(r => r.text());
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer');
        if (fresh) drawer.replaceChildren(...fresh.childNodes);
      } catch (e) {
        console.warn('[cart-gift] Drawer-Refresh fehlgeschlagen', e);
      }
    }

    try {
      const cart = await getCart();
      document.querySelectorAll('cart-count').forEach(el => { el.textContent = cart.item_count; });
    } catch (e) {}
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(async () => {
      if (await syncGift()) refreshUI();
    }, 350);
  }

  // 1) Impact-Event
  document.addEventListener('cart:change', schedule);

  // 2) Jede Warenkorb-Anfrage des Themes / von Apps (eigene Anfragen laufen über nativeFetch und werden ignoriert)
  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0] && args[0].url;
    const p = nativeFetch(...args);
    if (url && CART_MUTATION.test(url)) p.then(schedule, schedule);
    return p;
  };

  // 3) Vor dem Checkout noch einmal prüfen
  document.addEventListener('submit', async event => {
    const submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;
    event.preventDefault();
    await syncGift();
    window.location.href = root + 'checkout';
  });

  // 4) Beim Seitenaufruf prüfen
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  // Für das Rabattcode-Feld (cart-discount.js)
  window.cartRewardsUI = { sync: syncGift, refresh: refreshUI };
})();